define([
    'jquery',
    'module-oneExpand',
    'module-oneDrawer',
    'module-oneContact',
    'module-oneSubscribe',
    'module-oneMobileMenu',
    'jquery.hoverintent',
    'jquery.scrolltofixed',
    'jquery.scrollLock',
], function ($, OneExpand, OneDrawer, OneContact, OneSubscribe, OneMobileMenu) {

    "use strict";

    var ViewHeader = Backbone.View.extend({

        initialize: function (opts) {
            
            console.log('init header');
            
			var self = this;
			self.$body = self.$el;
            self.$header = $('#header-wrapper');
            self.$miniCart = $('#MiniCart');
            self.$mobileNav = $('#MobileNav');
            self.$searchBar = $('#SearchBar');
            self.$searchMenu = $('.snize-ac-results');
            self.$promoBanner = self.$header.find('.promo-banner');
            self.$navi = self.$header.find('.nav');
            
            self.initNavi();
            self.initSearch();
		},

		events: {
            'drawer-opt' : 'bodyClassCtl',
            'menu-opt' : 'bodyClassCtl'
		},
        
        bodyClassCtl : function(e){
            // Please prevent operation on more then one drawer at the same time
            var self = this;
            var type = e.type;
            if (type == 'drawer-opt') {
                self.$body.toggleClass('drawer-opt');
                self.$body.toggleClass('show-overlay');
            } else {
                // console.log('toggle body class');
                self.$body.toggleClass('show-overlay');
            }
        },
        
        initNavi: function() {
            var self = this;
            
            var $topLevelLink = self.$navi.find('.dropdown');
            
            $topLevelLink.on('mouseenter', function(){
                var $submenu = $(this).find('.submenu');
                var $megamenu = $(this).find('.MegaMenu');

                $submenu.attr('aria-hidden', "false");
                $megamenu.attr('aria-hidden', 'false');
                $(this).addClass('is-expanded');
            });

            $topLevelLink.on('mouseleave', function() {
                var $submenu = $(this).find('.submenu');
                var $megamenu = $(this).find('.MegaMenu');

                $submenu.attr('aria-hidden', 'true');
                $megamenu.attr('aria-hidden', 'true');
                $(this).removeClass('is-expanded');
            });
        },
        
        initSearch: function(){
            var self = this;

            self.searchCtl = OneDrawer.init({
                el: self.$body,
                drawerElem: '#' + self.$searchBar.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .search-toggle',
                openCallback: function(){
                    setTimeout(function(){ $('#searchbox input[name="q"]').focus() },100);
                },
                events: {
                    'click .search-form button' : function(e){
                        e.preventDefault();
                        var $form = $(e.currentTarget).parents('form');
                        if ($form.find('input').val()) {
                            this.closeDrawer();
                            $form.submit();
                        } else {
                            // May be show error message ...
                        }
                    },
                    'click #search-icon' : function (e) {
                        this.openCallback();
                    }
                }
            });

        },
        
        initMobileMenu: function(){
            var self = this;
            
            self.mobileMenuCtl = OneDrawer.init({
                el: self.$body,
                drawerElem: '#' + self.$mobileNav.attr('id'),
                triggerEvent: 'click',
                triggerElem: 'header .menu-toggle'
            });
            
            self.mobileInnerMenuCtl = OneMobileMenu.init({
                el: self.$mobileNav
            });
        },
		
        isMobile: function () {
            var self = this;
            var w = $(window).width();
            if (w <= ORW.responsiveSizes.large) {
                return true;
            }
            return false;
        },

    });

    return ViewHeader;

});